import { classNameSelector } from '@app/store/slices/ui_classname'
import { themeColorSelector } from '@app/store/slices/ui_theme_color'
import type { Store } from '@app/store/store'
import { storeMonitoring } from '@app/store/store'

export class DOMService {
  private store: Store
  private stack = new DisposableStack()

  constructor(store: Store) {
    this.store = store

    this.stack.use(
      storeMonitoring(this.store, themeColorSelector, themeColor => {
        const el = document.head.querySelector<HTMLMetaElement>("[name='theme-color']")
        if (!el) return
        el.content = themeColor
      })
    )

    this.stack.use(
      storeMonitoring(this.store, classNameSelector, className => {
        document.documentElement.className = className
      })
    )
  }

  [Symbol.dispose]() {
    this.stack.dispose()
  }
}
